import { useState } from "react"

import { Button } from "@coval/ui"
import { Printer } from "lucide-react"

import {
  printsTaggedPdf,
  UNTAGGED_PRINT_NOTICE,
} from "../utils/notebookAccessibleExport"
import { printNotebookCanvas } from "../utils/printNotebookCanvas"

export function NotebookPrintButton({
  id,
  title,
  disabled = false,
}: {
  id: string
  title: string
  disabled?: boolean
}) {
  const [error, setError] = useState("")
  const [notice, setNotice] = useState("")
  const [busy, setBusy] = useState(false)
  const print = async () => {
    setBusy(true)
    setError("")
    setNotice(printsTaggedPdf() ? "" : UNTAGGED_PRINT_NOTICE)
    try {
      await printNotebookCanvas(id, title)
    } catch (failure) {
      setError(
        failure instanceof Error
          ? failure.message
          : "Could not print the notebook.",
      )
    } finally {
      setBusy(false)
    }
  }
  return (
    <div>
      <Button
        variant="ghost"
        disabled={disabled || busy}
        onClick={() => void print()}
      >
        <Printer />
        {busy ? "Preparing…" : "Accessible PDF"}
      </Button>
      {notice && (
        <p role="status" className="max-w-sm text-sm text-coval-text-muted">
          {notice}
        </p>
      )}
      {error && (
        <p role="alert" className="text-sm text-coval-danger-text">
          {error}
        </p>
      )}
    </div>
  )
}
